<div
    class="overridable-input-wrapper"
    [class.is-overridden]="isOverridden"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    [hamTooltip]="this.systemValue != null && isOverridden ? tooltipLabel + ' : ' + (systemValue | finNumber) : ''"
    [withArrow]="true"
    [tooltipPosition]="'top-right'"
>
    <!-- Reset button (only visible when overridden) -->
    <button
        *ngIf="this.systemValue != null && isOverridden"
        type="button"
        class="reset-button"
        (click)="resetValue()"
        [attr.aria-label]="resetAriaLabel"
    >
        <i class="reset-icon"></i>
    </button>

    <!-- Input field -->
    <input
        type="number"
        class="number-input"
        [class.has-override]="isOverridden"
        [ngModel]="displayValue"
        (ngModelChange)="onInputValueChange($event)"
        [ngModelOptions]="{ standalone: true }"
        [disabled]="disabled"
        (blur)="markTouched()"
        hamInput
    />
</div>
